import { useState } from "react";
import PaytentLogo from "../assets/img/paytentLogo.png";
import hamburger from "../assets/img/hamburger.svg";
import close from "../assets/img/X.svg";

const Navbar = () => {
  const navBar = [
    { title: "Home", url: "/" },
    { title: "Pricing", url: "pricing" },
    { title: "About", url: "about" },
    { title: "Contact", url: "contact" },
  ];
  const [nav, setNav] = useState(false);

  const handleClick = () => {
    setNav(!nav);
  };

  return (
    <div>
      <div className="fixed z-20 bg-white w-full drop-shadow-md">
        <nav className="hidden md:flex justify-between items-center py-3 text-secondary container mx-auto">
          <div className="flex items-center">
            <a href="/">
              <img src={PaytentLogo} alt="Paytent Logo" />
            </a>
            <ul className="flex mx-20">
              {navBar.map(({ title, url }, idx) => (
                <li key={idx}>
                  <a href={url} className="mx-3 hover:opacity-70">
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <a
              href="/waitlist"
              className="bg-primary py-2 px-8 rounded-full text-white hover:opacity-70 duration-300"
            >
              Get Started
            </a>
          </div>
        </nav>
      </div>

      <div className="container mx-auto vh-10 flex md:hidden items-center justify-between px-3 ">
        <div className="p-3 z-30">
          <a href="/">
            <img src={PaytentLogo} alt="logo" className="" />
          </a>
        </div>
        <div onClick={handleClick} className="cursor-pointer p-3 z-30">
          {!nav ? (
            <img src={hamburger} alt="logo" className="" />
          ) : (
            <img src={close} alt="" className="" />
          )}
        </div>
      </div>
      <div
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 bg-white w-full h-screen flex flex-col justify-center items-center z-20"
        }
      >
        <ul className="text-3xl font-bold text-center">
          {navBar.map(({ title, url }, idx) => (
            <li key={idx} className="py-5">
              <a href={url} onClick={handleClick}>
                {title}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="/waitlist"
          className="bg-primary py-2 px-8 mt-10 rounded-full text-white hover:opacity-70 duration-300"
        >
          Get Started
        </a>
      </div>
    </div>
  );
};

export default Navbar;
